// extracted by mini-css-extract-plugin
export default {"componentModal":"componentModal__NN9II"};